// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36rw2","fullView":"styles_fullView__y56kF"};